import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        crowdfundingNominatifPur: [
          entity?.parameters?.crowdfundingNominatifPur || null,
          this.nominatifPurRequired(entity?.parameters)
            ? Validators.required
            : Validators.nullValidator,
        ],
        crowdfundingNominatifAdministredOption: [
          entity?.parameters?.crowdfundingNominatifAdministredOption || null,
        ],
        crowdfundingInsightChoice: [
          entity?.parameters?.crowdfundingInsightChoice || null,
          this.insightChoiceRequired(entity?.parameters)
            ? Validators.required
            : Validators.nullValidator,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  nominatifPurRequired(parameters: Parameters) {
    return (
      this.getAdditionalQuestions(
        parameters,
        CompanyFieldType.CROWDFUNDING_NOMINATIF_PUR,
      )?.required === 'MANDATORY' || false
    );
  }
  nominatifAdministredRequired(parameters: Parameters) {
    return (
      this.getAdditionalQuestions(
        parameters,
        CompanyFieldType.CROWDFUNDING_NOMINATIF_PUR,
      )?.required === 'MANDATORY' || false
    );
  }
  insightChoiceRequired(parameters: Parameters) {
    return (
      this.getAdditionalQuestions(
        parameters,
        CompanyFieldType.CROWDFUNDING_INSIGHT_CHOICE,
      )?.required === 'MANDATORY' || false
    );
  }
  getAdditionalQuestions(parameters: Parameters, type: any) {
    return parameters?.additionalQuestions?.find(q => q?.id === type);
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
